import { Component, OnInit, Injectable, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AuthService } from '../../../public/auth.service';
export { LoginComponent };

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
  providers: [AuthService]
})
class LoginComponent implements OnInit, AfterViewInit {
  title = '社團法人台灣腸治久安協會網站後台管理';
  showAuthError: boolean = false;

  constructor(public authService: AuthService, public router: Router) {

  }

  ngOnInit() {

  }


  ngAfterViewInit() {
    this.authService.afAuth.auth.onAuthStateChanged((result) => {
      console.log('this.authService.afAuth.auth.onAuthStateChanged');
      console.log(result);
      if (result) {
        this.router.navigate(['/maintain']);
      }
    });
  }

  login(email: string, password: string) {
    this.authService.login_admin(email, password).then((success) => {
      console.log('success = ' + success);
      this.showAuthError = !success;
      if (success) {
        let redirect = this.authService.redirectUrl && this.authService.redirectUrl !== undefined ? this.authService.redirectUrl : '/maintain';
        this.router.navigate([redirect]);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/maintain/independentPage/login/login.component.ts